export const state = {
  fuels: { workingRange: [null, null] },
  statFilters: { search: null, daterange: [null, null] },
  configurations: null,
  transactionConfigurations: {
    pytheas: {
      invoice: {
        E: [
          // { prop: "transactionId", width: "", editable: false, label: "id" },
          {
            prop: "description_business",

            editable: true,
            label: "BUSINESS",
            editWhen(rowData) {
              // _log_('???E..',rowData)

              return (
                  !rowData.description_business ||
                  ["subtotal", "sub total"].indexOf(
                      rowData.description_business.toLowerCase()
                  ) < 0
              );
            },
            formatter(val, colDefs, row, vm, allData) {
              if (!row || !val) return;
              if (["subtotal", "sub total"].indexOf(val.toLowerCase()) >= 0) {
                const from_pos = vm.findInArray(
                    allData,
                    {
                      transactionId: row.transactionId,
                    },
                    true
                );

                var sums = {
                  adults: 0,
                  children: 0,
                  description_transfer: 0,
                  description_handling: 0,
                };
                if (!from_pos) return val;
                for (let index = from_pos - 1; index >= 0; index--) {
                  const element = allData[index];
                  if (!isNaN(parseInt(element.description_adults)))
                    sums.adults += parseInt(element.description_adults);
                  if (!isNaN(parseInt(element.description_children)))
                    sums.children += parseInt(element.description_children);
                  if (!isNaN(parseFloat(element.description_transfer)))
                    sums.description_transfer += parseFloat(
                        element.description_transfer
                    );
                  if (!isNaN(parseFloat(element.description_handling)))
                    sums.description_handling += parseFloat(
                        element.description_handling
                    );
                  // _log_("sums..." + element.description_children,sums.children ,row);
                }
                _log_(
                    "sums..." + val,
                    row.description_children,
                    sums.children
                );
                var emit_event = false;
                if (parseInt(row.description_children) != sums.children) {
                  row.description_children = sums.children;
                  emit_event = true;
                }
                if (parseInt(row.description_adults) != sums.adults) {
                  row.description_adults = sums.adults;
                  emit_event = true;
                }
                if (
                    parseFloat(row.description_transfer) !=
                    sums.description_transfer
                ) {
                  row.description_transfer = sums.description_transfer;
                  emit_event = true;
                }
                if (
                    parseFloat(row.description_handling) !=
                    sums.description_handling
                ) {
                  row.description_handling = sums.description_handling;
                  emit_event = true;
                }
                if (emit_event)
                  vm.$emit("cell-change", {
                    prop: "description",
                    row: row,
                  });
              }

              return val;
            },
          },
          {
            editWhen(rowData) {
              // _log_('???E..',rowData)

              return (
                  !rowData.description_business ||
                  ["subtotal", "sub total"].indexOf(
                      rowData.description_business.toLowerCase()
                  ) < 0
              );
            },
            prop: "description_ticketNum",

            editable: true,
            label: "REF",
          },
          {
            editWhen(rowData) {
              // _log_('???E..',rowData)

              return (
                  !rowData.description_business ||
                  ["subtotal", "sub total"].indexOf(
                      rowData.description_business.toLowerCase()
                  ) < 0
              );
            },
            prop: "description_adults",

            editable: true,
            label: "ADL",
          },
          {
            editWhen(rowData) {
              // _log_('???E..',rowData)

              return (
                  !rowData.description_business ||
                  ["subtotal", "sub total"].indexOf(
                      rowData.description_business.toLowerCase()
                  ) < 0
              );
            },
            prop: "description_children",

            editable: true,
            label: "CHD",
          },
          {
            editWhen(rowData) {
              // _log_('???E..',rowData)

              return (
                  !rowData.description_business ||
                  ["subtotal", "sub total"].indexOf(
                      rowData.description_business.toLowerCase()
                  ) < 0
              );
            },
            prop: "description_handling",

            editable: true,
            label: "HANDLING",
          },
          {
            editWhen(rowData) {
              // _log_('???E..',rowData)

              return (
                  !rowData.description_business ||
                  ["subtotal", "sub total"].indexOf(
                      rowData.description_business.toLowerCase()
                  ) < 0
              );
            },
            prop: "description_transfer",

            editable: true,
            label: "TRANSFER",
          },

          {
            editWhen(rowData) {
              // _log_('???E..',rowData)

              return (
                  !rowData.description_business ||
                  ["subtotal", "sub total"].indexOf(
                      rowData.description_business.toLowerCase()
                  ) < 0
              );
            },
            prop: "costincl",
            width: "120px",
            editable: true,
            // editorcomponent: {
            //   is: "s-number"
            // },
            label: "TOTAL",
            formatter(val, colDefs, row, vm) {
              return val ? vm.$theMoney(val) + "&euro;" : "-";
            },
          },
          {
            editWhen(rowData) {
              // _log_('???E..',rowData)

              return (
                  !rowData.description_business ||
                  ["subtotal", "sub total"].indexOf(
                      rowData.description_business.toLowerCase()
                  ) < 0
              );
            },
            prop: "transactionId",
            width: "60px",
            label: "X",
            onlyEditMode: true,
            editable: true,
            sortable: false,
            editorcomponent: {
              is: "el-button",
              icon: "el-icon-delete",
              type: "danger",
              circle: true,
            },
            formatter(val, colDefs, row, vm) {
              return "-";
              // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
            },
          },
        ],
      },
      receipt: [
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)

            return (
                !rowData.description_business ||
                ["subtotal", "sub total"].indexOf(
                    rowData.description_business.toLowerCase()
                ) < 0
            );
          },
          prop: "description_coname",

          editable: true,
          label: "COMPANY",
        },

        {
          prop: "description_business",

          editable: true,
          label: "BUSINESS",
          editWhen(rowData) {
            // _log_('???E..',rowData)

            return (
                !rowData.description_business ||
                ["subtotal", "sub total"].indexOf(
                    rowData.description_business.toLowerCase()
                ) < 0
            );
          },
          formatter(val, colDefs, row, vm, allData) {
            if (!row || !val) return;
            if (["subtotal", "sub total"].indexOf(val.toLowerCase()) >= 0) {
              const from_pos = vm.findInArray(
                  allData,
                  {
                    transactionId: row.transactionId,
                  },
                  true
              );

              var sums = {
                adults: 0,
                children: 0,
                free: 0,
                quantity: 0,
              };
              if (!from_pos) return val;
              for (let index = from_pos - 1; index >= 0; index--) {
                const element = allData[index];
                if (!isNaN(parseInt(element.description_adults)))
                  sums.adults += parseInt(element.description_adults);
                if (!isNaN(parseInt(element.description_free)))
                  sums.free += parseInt(element.description_free);
                if (!isNaN(parseInt(element.description_children)))
                  sums.children += parseInt(element.description_children);
                if (!isNaN(parseFloat(element.quantity)))
                  sums.quantity += parseFloat(element.quantity);

                // _log_("sums..." + element.description_children,sums.children ,row);
              }
              _log_(
                  "sums..." + val,
                  row.description_children,
                  sums.children
              );
              var emit_event = false;
              if (parseInt(row.description_children) != sums.children) {
                row.description_children = sums.children;
                emit_event = true;
              }
              if (parseInt(row.description_free) != sums.free) {
                row.description_free = sums.free;
                emit_event = true;
              }
              if (parseInt(row.description_adults) != sums.adults) {
                row.description_adults = sums.adults;
                emit_event = true;
              }
              if (parseFloat(row.quantity) != sums.quantity) {
                row.quantity = sums.quantity;
                emit_event = true;
              }

              if (emit_event)
                vm.$emit("cell-change", {
                  prop: "description",
                  row: row,
                });
            }

            return val;
          },
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)

            return (
                !rowData.description_business ||
                ["subtotal", "sub total"].indexOf(
                    rowData.description_business.toLowerCase()
                ) < 0
            );
          },
          prop: "description_ticketNum",

          editable: true,
          label: "TICKET",
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)

            return (
                !rowData.description_business ||
                ["subtotal", "sub total"].indexOf(
                    rowData.description_business.toLowerCase()
                ) < 0
            );
          },
          prop: "description_adults",

          editable: true,
          label: "ADL",
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)

            return (
                !rowData.description_business ||
                ["subtotal", "sub total"].indexOf(
                    rowData.description_business.toLowerCase()
                ) < 0
            );
          },
          prop: "description_children",

          editable: true,
          label: "CHD",
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)

            return (
                !rowData.description_business ||
                ["subtotal", "sub total"].indexOf(
                    rowData.description_business.toLowerCase()
                ) < 0
            );
          },
          prop: "description_free",

          editable: true,
          label: "FREE",
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)

            return (
                !rowData.description_business ||
                ["subtotal", "sub total"].indexOf(
                    rowData.description_business.toLowerCase()
                ) < 0
            );
          },
          prop: "description_hotel",

          editable: true,
          label: "HOTEL",
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)

            return (
                !rowData.description_business ||
                ["subtotal", "sub total"].indexOf(
                    rowData.description_business.toLowerCase()
                ) < 0
            );
          },
          prop: "description_roomn",

          editable: true,
          label: "ROOM",
        },
        {
          // editWhen(rowData) {
          //   // _log_('???E..',rowData)

          //   return (
          //     !rowData.description_business ||
          //     ["subtotal", "sub total"].indexOf(
          //       rowData.description_business.toLowerCase()
          //     ) < 0
          //   );
          // },
          prop: "quantity",
          width: "120px",
          editable: false,
          // editorcomponent: {
          //   is: "s-number"
          // },
          label: "QUAN.",
          formatter(val, colDefs, row, vm, allData) {
            const q =
                (row.description_adults && row.description_adults != ""
                    ? parseInt(row.description_adults)
                    : 0) +
                (row.description_children && row.description_children != ""
                    ? parseInt(row.description_children)
                    : 0) +
                (row.description_free && row.description_free != ""
                    ? parseInt(row.description_free)
                    : 0);
            // _log_("qqqq...", q, row.quantity);
            const checkQ = q == "" ? "0" : q + "",
                ceckRow = row.quantity == "" ? "0" : row.quantity + "";
            if (checkQ != ceckRow) {
              // _log_("qqqq.FCCC..", q, row.quantity);
              row.quantity = q;
              vm.$emit("cell-change", {
                prop: "quantity",
                row: row,
              });
            }
            // if (q != parseInt(row.quantity)) {
            //   row.quantity = q;
            //   vm.$emit("cell-change", { prop: "quantity", row: row });
            // }
            return row.quantity;
          },
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)

            return (
                !rowData.description_business ||
                ["subtotal", "sub total"].indexOf(
                    rowData.description_business.toLowerCase()
                ) < 0
            );
          },
          prop: "costincl",
          width: "120px",
          editable: true,
          // editorcomponent: {
          //   is: "s-number"
          // },
          label: "TOTAL",
          formatter(val, colDefs, row, vm) {
            return val ? vm.$theMoney(val) + "&euro;" : "-";
          },
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)

            return (
                !rowData.description_business ||
                ["subtotal", "sub total"].indexOf(
                    rowData.description_business.toLowerCase()
                ) < 0
            );
          },
          prop: "transactionId",
          width: "60px",
          label: "X",
          onlyEditMode: true,
          editable: true,
          sortable: false,
          editorcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true,
          },
          formatter(val, colDefs, row, vm) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          },
        },
      ],
    },
    // sofarnew: {
    //   invoice: {
    //     Α: [
    vaggelis: {
      default: {
        default: [
          // {
          //   prop: "transactionId",
          //   width: "",
          //   editable: false,
          //   label: "id",
          // },
          {
            prop: "description",
            editorcomponentFactory(row) {
              return {
                queryOptions: {
                  as_array: true,
                  timologioId: row.timologioId,
                },
                is: "SAutoComplete",

                labelField: "description",
              };
            },
            editable: true,
            label: "Περιγραφή",
          },
          {
            width: "120px",
            prop: "quantity",

            editable: true,
            label: "Τεμάχια",
          },

          {
            editorcomponent: {
              is: "s-number",
            },
            prop: "unitcost",
            width: "120px",

            editable: true,
            label: "Τιμ.Μον.",
            formatter(val, colDefs, row, vm) {
              return vm.$theMoney(val) + "&euro;";
            },
          },

          {
            editorcomponent: {
              is: "s-number",
            },
            prop: "cost",
            width: "120",
            editable: true,
            label: "Κοστος",
            formatter(val, colDefs, row, vm) {
              return vm.$theMoney(val) + "&euro;";
            },
          },

          {
            prop: "costincl",
            width: "120px",
            editable: true,
            editorcomponent: {
              is: "s-number",
            },
            label: "Με ΦΠΑ",
            formatter(val, colDefs, row, vm) {
              return vm.$theMoney(val) + "&euro;";
            },
          },
          {
            prop: "transactionId",
            width: "60px",
            label: "X",
            onlyEditMode: true,
            editable: true,
            sortable: false,
            editorcomponent: {
              is: "el-button",
              icon: "el-icon-delete",
              type: "danger",
              circle: true,
            },
            formatter(val, colDefs, row, vm) {
              return "-";
            },
          },
        ],
      },
    },
    kriton: {
      receipt: [
        // { prop: "transactionId", width: "", editable: false, label: "id" },
        {
          prop: "description",

          editable: true,
          label: "ΠΕΡ.ΕΚΔΡΟΜΗ;ΠΕΛΑΤΕΣ;ΑΡ.ΔΕΛΤ.;ΕΝΗΛΙΚΕΣ;ΠΑΙΔΕΙΑ",
        },
        {
          width: "120px",
          prop: "quantity",

          editable: true,
          label: "ΑΤΟΜΑ",
        },

        {
          // editorcomponent: {
          //   is: "s-number"
          // },
          prop: "unitcost",
          width: "120px",

          editable: true,
          label: "ΤΙΜΗ ΕΚΔΡ.",
          formatter(val, colDefs, row, vm) {
            return vm.$theMoney(val) + "&euro;";
          },
        },

        {
          // editorcomponent: {
          //   is: "s-number"
          // },
          prop: "cost",
          width: "120",
          editable: true,
          label: "Κοστος",
          formatter(val, colDefs, row, vm) {
            return vm.$theMoney(val) + "&euro;";
          },
        },

        {
          prop: "costincl",
          width: "120px",
          editable: true,
          // editorcomponent: {
          //   is: "s-number"
          // },
          label: "Με ΦΠΑ",
          formatter(val, colDefs, row, vm) {
            return vm.$theMoney(val) + "&euro;";
          },
        },
        {
          prop: "transactionId",
          width: "60px",
          label: "X",
          onlyEditMode: true,
          editable: true,
          sortable: false,
          editorcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true,
          },
          formatter(val, colDefs, row, vm) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          },
        },
      ],
    },
  },
  // user : Medcare.user,
  // roles : Medcare.roles,
};

export const getters = {
  fuelsWorkingRange: (state) => state.fuels.workingRange,
  statFilters: (state) => state.statFilters,
  // transactionConfiguration: (state) => state.configurations,
  transactionConfiguration: (state) => (usergroup) =>
      state.transactionConfigurations[usergroup],
  // roles: state => state.roles,
};

export const mutations = {
  setFuelsWorkingRange(state, range) {
    state.fuels.workingRange = range;
  },
  setStatFilters(state, statFilters) {
    // for (const key in statFilters) {
    //     if (statFilters.hasOwnProperty(key)) {
    //         const element = statFilters[key];
    //         this.$set

    //     }
    // }
    state.statFilters = statFilters;
  },
};

export const actions = {};
